import { CalendarOff, FileText, House, UserRound } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';
import { ErrorState } from '@/components/error-state';
import { useTranslation } from '../../i18n/useTranslation';
import { portalPath } from './portal-paths';

export function PortalNotFoundPage() {
  const { t } = useTranslation(['portal', 'common']);
  const navigate = useNavigate();
  const { companySlug = '' } = useParams<{ companySlug: string }>();
  const homePath = portalPath(companySlug);

  function handleGoBack() {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(homePath);
    }
  }

  return (
    <ErrorState
      code="404"
      accent="blue"
      eyebrow={t('common:notFound.eyebrow')}
      title={t('common:notFound.title')}
      description={t('common:notFound.description')}
      primaryAction={{
        label: t('common:notFound.back'),
        onClick: handleGoBack,
      }}
      secondaryAction={{
        label: t('notFound.openHome'),
        href: homePath,
      }}
      helpTitle={t('common:notFound.helpTitle')}
      helpLinks={[
        {
          href: homePath,
          label: t('nav.home'),
          description: t('notFound.homeHint'),
          icon: <House aria-hidden="true" />,
        },
        {
          href: portalPath(companySlug, 'payslips'),
          label: t('nav.payslips'),
          description: t('home.payslipsHint'),
          icon: <FileText aria-hidden="true" />,
        },
        {
          href: portalPath(companySlug, 'absences'),
          label: t('nav.absences'),
          description: t('home.absencesHint'),
          icon: <CalendarOff aria-hidden="true" />,
        },
        {
          href: portalPath(companySlug, 'profile'),
          label: t('nav.profile'),
          description: t('home.profileHint'),
          icon: <UserRound aria-hidden="true" />,
        },
      ]}
      variant="in-layout"
    />
  );
}
